<template>
  <div class="wrap">
    <div class="con">
      <img src="./imgs/info1.jpeg" alt="">
      <p class="tt">雷小安是一家服务于二奢行业的平台化公司，安洁利创始人“雷雨春”先生于2022年创办，由其母公司品牌安洁利集团建立。雷小安平台致力于建立货品标准认证、经营管理标准、从业能力认证和信用标准认证等四大认证体系，并通过打造AI工具、SAAS工具、小安商学院和超级仓等工具或平台，建立行业鉴定、估价的标准，并通过商家工具、知识培训赋能行业商家，以标准化服务实现交易新体验，以技术化手段构建高端二奢生态链，最终打造值得信任的全球性供应链流通体系。</p>
      <img class="img_b" src="./imgs/info2.png" alt="">
      <p class="tt">公司一直秉承“让行业更健康、更便捷”的企业宗旨和“多做事，少废话；干实事，搞实业”的企业原则，在激烈的国内市场大潮中稳固发展，为二奢行业发展助力，开启新篇章，让行业更健康、更便捷。</p>
      <img src="./imgs/info3.jpeg" alt="" />
      <img src="./imgs/info4.jpeg" alt="" />
      <p class="tt">很多单位认为收取培训费是唯一能跟学员的合作产生互利，而我们可以严肃的告诉大家：培训结束，我们的合作才刚刚开始！我们相信：长久的产品共赢、长久的技术保障会让我们的合作更流长！相信：所有的合作、所有的扶持都是建立在我们共赢的基础上！</p>
      <p class="tt">在学员培训结束后，我们会提供一系列的开业支持、指导;有偿提供一系列的产品、设备、工具供学员开业使用，并保证有效的指导各个学员继续难关；一系列的管理软件指导介绍、并提供会员管理合同、客户接单合同、以及各类风险规避技巧,提供一系列店面设计方案、提供本部学员实体店参考图、名片、传单、折页、海报等一系列；前台接待、会员推荐、加工流程、管理流程等一系列指导、建议。</p>
      <p class="tt img_b">在夏天我们会定期召开一系列的全国性技术交流会，本部会通知各学员前来参加,随时接受每位学员的网络技术咨询、并给与有效的技术指导、特殊物件可邮寄本公司代加工,本部为全国产品开发商和供应商、保证了产品供应线的完整性,根据本部的经验积累、以及日常的管理模式总结，提供具有实施性、实用性的营销管理模式！再淡季期间、我们会定期安排工作人员上门指导部分学员，并给所有学员做详细的工作总结。</p>
    </div>
  </div>
</template>

<script>

export default {
  name: "info",
  data() {
    return {
    };
  },
  methods: {
    
  }
};
</script>

<style lang="scss" scoped>
.wrap{
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .con {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 50px;
    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .tt{
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
    }
    .img_b{
      margin-bottom: 70px;
    }
  }
}
</style>
